import { type IsTwinsNeededResp as SchemaIsTwinsNeededResp } from '../schemas/IsTwinsNeededResp';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const IsTwinsNeededContentType = '' as const;
export type IsTwinsNeededRequest = void;
export type IsTwinsNeededResponses = {
    '200': {
        'application/json': SchemaIsTwinsNeededResp;
    };
};
export type IsTwinsNeededResponseSuccess = IsTwinsNeededResponses['200']['application/json'];
export type IsTwinsNeededSearchParams = undefined;
export type IsTwinsNeededPathParameters = undefined;
export const IsTwinsNeededUrl = '/warehouses/is-twins-needed' as const;
export const IsTwinsNeededMethod = 'GET' as const;
export const getIsTwinsNeededUrl = (_params?: IsTwinsNeededPathParameters) => IsTwinsNeededUrl;
